import React from 'react';
import { useIntl } from 'react-intl';

import { Select } from '../../../forms';
import {
    GROUP_ACCESS_LEVEL_LABELS,
    getAccessLevelOptions
} from '../../../../utils/internalChatGroups';

import './group-access-level-select.scss';

/** Seletor do nível de acesso de um participante. As opções dependem do papel de
 *  cadastro dele: sem "Gerenciar grupo" para agente ou papel desconhecido.
 */
const GroupAccessLevelSelect = ({ id, role, value, onChange, disabled = false }) => {
    const intl = useIntl();

    const options = React.useMemo(() => {
        return getAccessLevelOptions(role, value).map(level => ({
            value: level,
            label: intl.formatMessage({ id: GROUP_ACCESS_LEVEL_LABELS[level] })
        }));
    }, [role, value, intl]);

    /** O Select tem um botão de limpar: sem nível não há o que enviar, então limpar
     *  mantém o valor atual.
     */
    const handleChange = ({ option }) => {
        if (option && option.value && option.value !== value) {
            onChange(option.value);
        }
    };

    return (
        <div className="group-access-level-select">
            <Select
                id={id}
                name={id}
                size="sm"
                placeholder={intl.formatMessage({ id: "Permissão" })}
                options={options}
                value={options.find(option => option.value === value) || null}
                onChange={handleChange}
                disabled={disabled}
            />
        </div>
    );
};

export default React.memo(GroupAccessLevelSelect);
